import React from 'react';
import { Seo } from '@/components/common/Seo';
import { PageHero } from '@/components/common/PageHero';
import { useContent } from '@/context/ContentContext';

const CONTENT = {
  privacy: {
    label: 'Legal',
    title: 'Privacy Policy',
    body: [
      'This Privacy Policy explains how OPHIR SUPPLY handles information submitted through this website. We collect the information you provide via our supplier, buyer and contact forms in order to review commercial opportunities and respond to inquiries.',
      'We use submitted information solely for legitimate business purposes, including evaluating supply opportunities, communicating with you and maintaining internal records. We do not sell your information.',
      'Uploaded documents are stored securely and accessed only by authorised OPHIR SUPPLY personnel for commercial review. You may request the removal of your submission by contacting us.',
      'This is a placeholder policy. A finalised Privacy Policy will be published once verified by OPHIR SUPPLY.',
    ],
  },
  terms: {
    label: 'Legal',
    title: 'Terms of Use',
    body: [
      'By using this website you agree to use it for lawful, professional purposes only. The content on this site is provided for general information about OPHIR SUPPLY and does not constitute an offer, guarantee or binding commitment.',
      'Submitting a form does not guarantee account approval, supplier onboarding or a purchase commitment. All product opportunities are subject to commercial review, market suitability, supplier approval, documentation, regulatory requirements, inventory availability and agreed purchasing terms.',
      'This is a placeholder document. Finalised Terms of Use will be published once verified by OPHIR SUPPLY.',
    ],
  },
  accessibility: {
    label: 'Accessibility',
    title: 'Accessibility Statement',
    body: [
      'OPHIR SUPPLY is committed to making this website accessible to as many people as possible. We aim to meet WCAG 2.1 AA guidelines, including keyboard navigation, visible focus states, sufficient colour contrast and descriptive alternative text for imagery.',
      'We continually review and improve the accessibility of our site. If you experience any difficulty accessing content, please contact us so we can assist and address the issue.',
    ],
  },
};

export default function Policy({ kind }) {
  const { content } = useContent();
  const data = CONTENT[kind] || CONTENT.privacy;
  return (
    <>
      <Seo title={`${data.title} | OPHIR SUPPLY`} description={`${data.title} for OPHIR SUPPLY.`} />
      <PageHero label={data.label} title={data.title} />
      <section className="bg-white">
        <div className="container-ophir py-16 lg:py-20">
          <div className="max-w-[72ch] space-y-5">
            {data.body.map((p, i) => (
              <p key={i} className="text-[16.5px] leading-relaxed text-ophir-muted">{p}</p>
            ))}
            {content?.contact?.email && (
              <p className="text-[16.5px] text-ophir-navy">Contact: {content.contact.email}</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
